export const SEARCH_TAGS_FAILURE = 'SEARCH_TAGS_FAILURE';

export const searchTagsFailure = ( payload: Error ) => ({
    type: SEARCH_TAGS_FAILURE,
    payload,
    error: true,
});